import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { getCheckedOptionFromView, PRIVATE } from '../../getCheckedOptionFromView';
import { jsx as _jsx } from "react/jsx-runtime";
export const PrivateRadioOption = ({
  viewUpdates,
  setViewUpdates
}) => {
  const isChecked = getCheckedOptionFromView(viewUpdates) === PRIVATE;
  const onRadioChange = useCallback(() => {
    setViewUpdates({
      private: true,
      teamId: undefined
    });
  }, [setViewUpdates]);
  return /*#__PURE__*/_jsx(RadioInput, {
    checked: isChecked,
    onChange: onRadioChange,
    "data-test-id": `view-sharing-private-checked=${isChecked}`,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.modals.manageSharing.private"
    })
  });
};